import {register} from '../vendor/theme-scripts/theme-sections';
import {newsletterCheckForResultSection} from '../globals/newsletter';
import {PopoutSelect} from '../features/popout';
import {accordion} from '../features/accordion';
import {shopPayLink} from '../features/shop-pay-link';

register('footer', [accordion, newsletterCheckForResultSection, shopPayLink]);

if (!customElements.get('popout-select')) {
  customElements.define('popout-select', PopoutSelect);
}
